import CookiesJS from 'cookies-js';

// Группа: либо выбранная из списка, либо введённая руками, если
// выбрали «Другая группа…».
function readGroup($) {
    const selected = $('#group').val();
    if (selected !== '__new__') return selected;
    return ($('#groupNew').val() || '').trim();
}

// Пять полей разметки читаются по data-атрибуту: добавится шестая
// непереносимость — здесь править не придётся.
function collectIntolerances($) {
    const marks = {};
    $('[data-intolerance]').each(function () {
        marks[$(this).attr('data-intolerance')] = $(this).val();
    });
    return Object.keys(marks).length ? marks : undefined;
}

export function initProducts($, apiClient) {
    // Поле для новой группы показывается только когда выбрали
    // «Другая группа…» — в остальное время оно лишний шум.
    $('#group').on('change', function () {
        $('#groupNew').toggleClass('d-none', $(this).val() !== '__new__');
        if ($(this).val() === '__new__') $('#groupNew').focus();
    });

    function getStatValue(key) {
        const val = $(`#${key}`).val();
        if (val === '') return undefined;
        return parseFloat(val);
    }

    function getStats(keys) {
        const stats = {};
        for (const key of keys) {
            stats[key] = getStatValue(key);
        }
        return stats;
    }

    $('form.product-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const images = [];
            $('#images .upload-images__image-container').each(function () {
                images.push($(this).attr('data-key'));
            });
            const product = {
                title: $('#title').val(),
                state: $('#state').val(),
                group: readGroup($),
                description: $('#description').val(),
                images,
                stats: getStats([
                    'proteins',
                    'fat',
                    'carbohydrate',
                    'cellulose',
                    'vitaminA',
                    'betaCarotene',
                    'alphaCarotene',
                    'folic',
                    'clorine',
                    'iodine',
                    'vitaminD',
                    'vitaminD2',
                    'vitaminD3',
                    'vitaminE',
                    'vitaminK',
                    'vitaminC',
                    'vitaminB1',
                    'vitaminB2',
                    'vitaminB3',
                    'vitaminB4',
                    'vitaminB5',
                    'vitaminB6',
                    'vitaminB7',
                    'vitaminB9',
                    'vitaminB12',
                    'calcium',
                    'iron',
                    'magnesium',
                    'phosphorus',
                    'potassium',
                    'sodium',
                    'zinc',
                    'copper',
                    'manganese',
                    'selenium',
                    'fluorine',
                    'water',
                    'ash',
                    'sugar',
                    'fiber',
                    'starch',
                    'cholesterol',
                    'transfats'
                ]),
                units: $('#units').val(),
                unitsToGramms: parseFloat($('#unitsToGramms').val()),
                deleted: !!$('#deleted').prop('checked'),
                isExcludable: !!$('#isExcludable').prop('checked'),
                // пустая строка — «не размечено», сервер примет её как отсутствие
                origin: $('#origin').val() || undefined,
                // Отметки непереносимостей: пустого значения не бывает,
                // поэтому собираем все пять полей целиком, а не только
                // изменённые. Аллерген пустой — значит, его нет.
                intolerances: collectIntolerances($),
                allergen: $('#allergen').val() || undefined,
            };
            if (!_id) {
                const result = await apiClient.create('/products', product, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/products/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/products', _id, product, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
